import { render, staticRenderFns } from "./FileUploader.vue?vue&type=template&id=63538236&scoped=true&"
import script from "./FileUploader.vue?vue&type=script&lang=js&"
export * from "./FileUploader.vue?vue&type=script&lang=js&"
import style0 from "./FileUploader.vue?vue&type=style&index=0&id=63538236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63538236",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63538236')) {
      api.createRecord('63538236', component.options)
    } else {
      api.reload('63538236', component.options)
    }
    module.hot.accept("./FileUploader.vue?vue&type=template&id=63538236&scoped=true&", function () {
      api.rerender('63538236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/FileUploader.vue"
export default component.exports